import React from 'react'
import './LoadingSpinner.css'

const LoadingSpinner = () => {
  return (
    <div className="loading-container">
      <div className="loading-spinner"></div>
      <p>Chargement de l'application EMDR...</p>
    </div>
  )
}

export default LoadingSpinner 